import { useOktaAuth } from "@okta/okta-react";

export default function useAuth() {
  const { authState } = useOktaAuth();
  return {
    accessToken: authState?.accessToken?.accessToken,
    isAuth: authState?.isAuthenticated,
  };
}
